import { IPaymeSaleData } from '../../admin-panel';

export enum PaymentProvider {
  HYP = 'hyp',
  PAYME = 'payme',
  // CARDCOM = 'cardcom',
  // TRANZILA = 'tranzila',
  // PAYPLUS = 'payplus',
  // GROW = 'grow',
  // UPAY = 'upay'
}

export enum InvoiceProvider {
  EZCOUNT = 'ezcount',
  PAYME = 'payme-invoice',
  SMARTBEE = 'smartbee',
  // ICOUNT = 'icount',
  // INVOICE4U = 'invoice4u',
  // MORNING = 'morning'
}

export type PaymentIntegrationConfigCredentials = HypIntegrationParams | PaymeIntegrationParams;
export type InvoiceIntegrationConfigCredentials = EzcountIntegrationParams | PaymeInvoicesIntegrationParams | SmartBeeIntegrationParams;

type PaymeInvoicesIntegrationParams = Record<string, any>;

interface IntegrationPaymentParamsBase {
  key: string;
}

export interface HypIntegrationParams extends IntegrationPaymentParamsBase {
  masof: string;
  paas: string;
}

export interface PaymeIntegrationParams extends IntegrationPaymentParamsBase {
  seller_payme_id: string;
  seller_public_key: string;
  seller_dashboard_signup_link: string;
  // key: string; value of 'seller_payme_secret'
}

/** A physical PayMe card terminal connected to the business's PayMe account. */
export interface IPaymePosTerminal {
  /** PayMe's `pos_id` for the terminal */
  posId: string;
  /** Shown to staff when picking a terminal, e.g. "קופה ראשית" */
  name?: string;
}

export interface PaymeSettings {
  paymentMethods: IPaymeSaleData['paymentMethods'];
  /** Set by hand in the DB (paymentIntegration.paymentConfig.settings.posTerminals); no UI. */
  posTerminals?: IPaymePosTerminal[];
}

export interface EzcountIntegrationParams {
  key: string;
  host?: string;
}

export interface SmartBeeIntegrationParams {
  /**
   * Per-business SmartBee dealer identifier ("providerUserToken"), supplied by
   * SmartBee support. The integrator credentials (clientId + password) and host
   * are configured system-wide via env vars, not per business.
   */
  providerUserToken: string;
  /** Optional base URL override (defaults to env / SmartBee host) */
  host?: string;
}

export interface IPaymentIntegrationConfig {
  provider: PaymentProvider;
  credentials: PaymentIntegrationConfigCredentials;
  sandboxMode?: boolean;
  settings?: PaymeSettings | Record<string, any>;
  hasInvoices?: boolean;
}

export interface IInvoiceIntegrationConfig {
  provider: InvoiceProvider;
  credentials?: InvoiceIntegrationConfigCredentials;
  autoGenerateInvoice?: boolean;
  settings?: Record<string, any>;
}

export interface IBusinessPaymentIntegration {
  paymentConfig?: IPaymentIntegrationConfig;
  invoiceConfig?: IInvoiceIntegrationConfig;
}
